<template>
  <nav
    :class="['navbar navbar-expand-lg bg-transparent p-0 fixed-top mt-20', { sticky: isSticky }]"
  >
    <div class="container mw-1720 bg-opacity px-50 position-relative">

      <!-- Logo -->
      <RouterLink class="navbar-brand" to="/">
        <img
          :src="nav.logo_url || defaultLogo"
          class="main-logo"
          alt="logo"
        />
        <img
          :src="nav.logo_url || defaultLogo"
          class="white-logo d-none"
          alt="logo"
        />
      </RouterLink>

      <a class="navbar-toggler" @click="stateStoreInstance.responsiveNavbar">
        <span class="burger-menu">
          <span class="top-bar"></span>
          <span class="middle-bar"></span>
          <span class="bottom-bar"></span>
        </span>
      </a>

      <!-- CMS-driven nav links -->
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ms-auto">
          <li
            v-for="link in visibleLinks"
            :key="link.url"
            class="nav-item"
          >
            <RouterLink class="nav-link" :to="link.url">{{ link.label }}</RouterLink>
          </li>
        </ul>
      </div>

      <!-- Right-side actions -->
      <ul class="d-flex ps-0 mb-0 list-unstyled justify-content-end align-items-center others-options">
        <li class="d-none d-sm-inline-block">
          <a :href="'tel:' + nav.phone" class="call icon">
            <i class="ti ti-phone-incoming"></i>
          </a>
        </li>
        <li class="d-xl-none">
          <RouterLink :to="authStore.isLoggedIn ? '/dashboard' : '/login'" class="search icon">
            <i class="ti ti-user"></i>
          </RouterLink>
        </li>

        <template v-if="authStore.isLoggedIn">
          <li class="d-none d-xl-flex align-items-center gap-2">
            <RouterLink to="/dashboard" class="btn btn-sm">
              <span class="border-style">{{ authStore.user?.name }}</span>
            </RouterLink>
            <RouterLink v-if="authStore.isAdmin" to="/admin" class="btn btn-sm">
              <span class="border-style">Admin</span>
            </RouterLink>
            <button class="btn" @click="handleLogout">
              <span class="border-style">Logout</span>
            </button>
          </li>
        </template>
        <template v-else>
          <li class="d-none d-xl-block">
            <RouterLink to="/login" class="btn me-2">
              <span class="border-style">Login</span>
            </RouterLink>
          </li>
          <li class="d-none d-xl-block">
            <RouterLink :to="nav.cta_url || '/'" class="btn">
              <span class="border-style">{{ nav.cta_text || 'Get Started' }}</span>
            </RouterLink>
          </li>
        </template>
      </ul>

    </div>
  </nav>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import stateStore from "@/utils/store";
import { useAuthStore } from "@/store/auth";
import { useContent } from "@/composables/useContent";

const defaultNavDefaults = {
  logo_url: "",
  phone: "125487568",
  cta_text: "Get Started",
  cta_url: "/",
  links: [
    { label: "Home",           url: "/",                visible: true },
    { label: "World Cup 2026", url: "/world-cup-2026",  visible: true },
    { label: "Blog",           url: "/blog",            visible: true },
    { label: "Pricing",        url: "/pricing",         visible: true },
    { label: "Channel List",   url: "/channels",        visible: true },
    { label: "FAQ",            url: "/faq",             visible: true },
    { label: "About Us",       url: "/about-us",        visible: true },
    { label: "Contact",        url: "/contact-us",      visible: true },
  ],
};

export default defineComponent({
  name: "NavbarTwo",
  setup() {
    const isSticky = ref(false);
    const stateStoreInstance = stateStore;
    const authStore = useAuthStore();
    const router = useRouter();

    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const defaultLogo = require("@/assets/images/white-logo.svg");

    const { content: nav } = useContent("navigation", defaultNavDefaults);

    const visibleLinks = computed(() =>
      (nav.value.links ?? []).filter((l: any) => l.visible !== false)
    );

    onMounted(() => {
      window.addEventListener("scroll", () => {
        isSticky.value = window.scrollY >= 100;
      });
    });

    async function handleLogout() {
      await authStore.logout();
      router.push("/login");
    }

    return {
      isSticky, stateStoreInstance, authStore,
      nav, visibleLinks, defaultLogo, handleLogout,
    };
  },
});
</script>
